import { BaseService } from "@/services/BaseService";
import type {
  ServiceAutoReplySettings,
  UpdateServiceAutoReplySettingsRequest,
} from "@/types/serviceAutoReply";

class ServiceAutoReplyService extends BaseService {
  private getBasePath(hotelId: string): string {
    return `/hotels/${hotelId}/ai/service-auto-replies`;
  }

  getAll(hotelId: string): Promise<ServiceAutoReplySettings[]> {
    return this.get<ServiceAutoReplySettings[]>(this.getBasePath(hotelId));
  }

  update(
    hotelId: string,
    serviceId: string,
    data: UpdateServiceAutoReplySettingsRequest,
  ): Promise<ServiceAutoReplySettings> {
    return this.put<ServiceAutoReplySettings>(
      `${this.getBasePath(hotelId)}/${serviceId}`,
      data,
    );
  }
}

export const serviceAutoReplyService = new ServiceAutoReplyService();
